import { Box, ITheme, SvgIcon, Typography, lighten, useTheme } from '@mui/material';
import React from 'react';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export interface IGlobalStatisticsItemProps{
    title: string;
    symbol: React.FunctionComponent<React.SVGProps<SVGSVGElement> & {title?: string | undefined;}>;
    value: string;
    proportion?: number;
    change?: number;
    color: string;
}

const GlobalStatisticsItem: React.FC<IGlobalStatisticsItemProps> = ({ title, symbol, value, proportion, change, color}) => {
    const theme = useTheme() as ITheme;
    return <Box display={"flex"} gap={"14px"} width={"300px"}>
        <Box display={"flex"} width={"52.01px"} height={"49.22px"} bgcolor={color} alignItems={"center"} justifyContent={"center"} color={theme.palette.primary.dark} borderRadius={"8px"} boxShadow={"0px 4px 8px -2px #1018281A;"} >
            <SvgIcon component={symbol} sx={{ color: theme.palette.common.white, width: "20px", height: "20px" }} inheritViewBox />
            {/* <img src={symbol} /> */}
        </Box>
        <Box display={"flex"} flexDirection={"column"} gap={"2px"} justifyContent={"center"}>
            <Typography fontSize={"14px"} lineHeight={"17.07px"} fontWeight={"400"}>{title}</Typography>
            <Box display={"flex"} gap={"10px"}>
                <Typography fontSize={"20px"} fontWeight={"800"} lineHeight={"24.38px"}>{value}</Typography>
                <Box display={"flex"} flexDirection={"column"} justifyContent={"end"} alignItems={"end"} paddingBottom={"4px"}>
                    {/* {change!== undefined && change !== 0 && <Box display={"flex"}>
                        {change > 0 ?
                            <KeyboardArrowUpIcon sx={{ fontSize: "16px" }} />
                            :
                            <KeyboardArrowDownIcon sx={{ fontSize: "16px" }} />
                        }
                        <Typography fontSize={"12px"} lineHeight={"14.63px"} fontWeight={"500"}>{Math.abs(change)}</Typography>
                    </Box>} */}
                    {proportion !== undefined && proportion !== 0 && <Box width={"124px"} height={"5px"} bgcolor={lighten(color,0.75)} borderRadius={"20px"}>
                        <Box width={`${124*proportion}px`} height={"5px"} bgcolor={color} borderRadius={"20px"} />
                    </Box>}
                </Box>
            </Box>
        </Box>
    </Box>;
}

export default GlobalStatisticsItem;